import { useState } from 'react';
import './rightBodyCardF1.sass';

/**
 * Muestra la parte derecha de la tarjeta de Fórmula 1.
 * Puede incluir: podio de corredores o imagen del circuito, dependiendo del estado del evento.
 */
export default function RightBodyCardF1({ data }) {
  const { game_name, class: clase, race_results } = data;
  const { circuit_image, podium = [] } = race_results || {};
  const [isDefaultImage, setIsDefaultImage] = useState(false);

  const hasPodium = Array.isArray(podium) && podium.length > 0;
  const isValidClass = !['clarosports-next-game', 'clarosports-error-game'].includes(clase);
  const showPodium = hasPodium && isValidClass;

  // Renderiza los nombres y banderas del podio
  const renderPodiumNames = () => (
    <div className="card-f1__body-right-podiumName">
      {podium.map((pilot, index) => (
        <div key={`${pilot.firstName}-${index}`} className="card-f1__body-right-name">

          <div className="card-f1__body-right-podium-span">
            <span className={`podium-position ${index === 0 ? 'ganadorf1' : ''}`}>{index + 1}</span>
          </div>

          <div className={`bandera-f1 bandera-${pilot.nationalityCode}`} />
          <p className="podium-name">{pilot.firstName} {pilot.lastName}</p>
        </div>
      ))}
    </div>
  );

  // Renderiza las posiciones del podio
  const renderPodiumPositions = () => (
    <div className="card-f1__body-right-podium">
      {podium.map((elemento, index) => (
        <div className='podiumTime' key={`${elemento.firstName}-${index}`}>
          <span>{elemento.timeString}</span>
        </div>
      ))}
    </div>
  );

  // Renderiza la imagen del circuito si no hay podio o la clase no es válida
  const renderCircuitImage = () => (
    <div className={`card-f1__body-right-trail${isDefaultImage ? '-default' : ''}`}>
      {!isDefaultImage && (
        <img
          src={circuit_image}
          alt={game_name}
          loading="lazy"
          onError={() => setIsDefaultImage(true)}
        />
      )}
    </div>
  );

  return (
    <div className='card-f1__body-right'>
      {showPodium && (
        <>
          {renderPodiumNames()}
          {renderPodiumPositions()}
        </>
      )}
      {!showPodium && renderCircuitImage()}
    </div>
  )
}